import api from '@/api'

const actions = {
  async getMarkrtingActivitiesList () {
    const {data} = await api.deployApi.getMarketingActivities()
    return data
  },
  async editMarketingActivity ({commit, dispatch}, payload) {
    const result = await api.deployApi.editMarketingActivity(payload)
    return result
  },
  async getAllPayMethod () {
    const {data} = await api.deployApi.getAllPayMethod()
    return data
  },
  async addActivityTemplate ({commit, dispatch}, payload) {
    const data = await api.deployApi.addActivityTemplate(payload)
    return data
  },
  async getActivityTemplateList ({commit, dispatch}, payload) {
    const {data} = await api.deployApi.getActivityTemplateList(payload)
    return data
  },
  async updateActivityTemplate ({commit, dispatch}, payload) {
    const data = await api.deployApi.updateActivityTemplate(payload)
    return data
  },
  async getActivityTemplate ({commit, dispatch}, payload) {
    const {data} = await api.deployApi.getActivityTemplate(payload)
    return data
  },
  async updateActivityStatus ({commit, dispatch}, payload) {
    const data = await api.deployApi.updateActivityStatus(payload)
    return data
  },
  async uploadFile({commit, dispatch}, payload) {
    const data = await api.deployApi.uploadFile(payload)
    return data
  },
}

export default {
  namespaced: true,
  actions,
}
